module.exports = __webpack_public_path__ + "img/Squirrel.ee4d8e54.png";